export default function scroller () {
    const elems = document.querySelectorAll('.our_solutions_scroller .swiper, .company_logos_scroller .swiper');

    if (!elems.length) {
        return;
    }

    elems.forEach(el => {
        const direction = el.getAttribute('data-direction');
        const duration = el.getAttribute('data-speed');
        const dir = (direction === 'left-to-right');

        const ss = new Swiper(el, {
            spaceBetween: 16,
            centeredSlides: true,
            speed: parseInt(duration, 10) * 100,
            autoplay: {
                delay: 1,
                reverseDirection: dir
            },
            loop: true,
            slidesPerView: 'auto',
            allowTouchMove: false,
            disableOnInteraction: true,
            updateOnWindowResize: false
        });
    });
}
